import { strategyToOptions } from "@/common/utils/strategyToOptions";

export const applicableEstablishmentCommercialKind = {
  all: 'Todos',
  only_on_available_to_everyone: 'Apenas para estabelecimentos externos',
  only_on_internal_base: 'Apenas para estabelecimentos da base própria',
};

export const applicableEstablishmentCommercialKindOptions = strategyToOptions(applicableEstablishmentCommercialKind);
